module.exports = __webpack_public_path__ + "img/20191009151351728.9a3b75ac.jpg";